import { TestCaseRepository } from '@/domain/repositories/testCase/TestCaseRepository'
import { TestCase } from '@/domain/value_objects/testCase/TestCase'

export class GetJudgeCaseListUseCase {
  constructor(private repository: TestCaseRepository) {}

  async getJudgeCaseList(problemId: string): Promise<TestCase[]> {
    try {
      const data = await this.repository.getJudgeCaseList(problemId)
      return data
    } catch (error) {
      console.error(`Error in GetJudgeCaseListUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
